/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function Train(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M7.456 17.348a.833.833 0 0 1 .23 1.156L5.604 21.63a.833.833 0 0 1-1.386-.925L6.3 17.58a.833.833 0 0 1 1.156-.23zm12.314 3.356a.833.833 0 1 1-1.387.925L16.3 18.504a.833.833 0 1 1 1.387-.925l2.083 3.125zM18.66 14.5a1.848 1.848 0 0 1-1.49 1.825 28.672 28.672 0 0 1-5.177.675 28.64 28.64 0 0 1-5.166-.673 1.858 1.858 0 0 1-1.5-1.827V5.76A3.763 3.763 0 0 1 9.086 2H14.9a3.763 3.763 0 0 1 3.759 3.76v8.74zM12.827 3.875v4.603a.21.21 0 0 0 .2.208 20.628 20.628 0 0 1 3.711.467.208.208 0 0 0 .255-.203V5.76a2.094 2.094 0 0 0-2.092-2.093h-1.866a.208.208 0 0 0-.208.208zM6.993 5.759V8.95a.208.208 0 0 0 .255.203 20.628 20.628 0 0 1 3.712-.467.21.21 0 0 0 .2-.208V3.875a.208.208 0 0 0-.208-.208H9.086a2.094 2.094 0 0 0-2.093 2.092zm1.459 7.074a.833.833 0 1 0 0-1.666h-1.25a.417.417 0 0 0-.417.416v.834c0 .23.186.416.417.416h1.25zm5.416 2.377v-1.543a.21.21 0 0 0-.208-.209h-3.333a.21.21 0 0 0-.209.209v1.542a.21.21 0 0 0 .184.208c.56.074 1.126.116 1.691.125a14.672 14.672 0 0 0 1.692-.125.21.21 0 0 0 .183-.207zm2.917-2.377a.417.417 0 0 0 .417-.416v-.834a.417.417 0 0 0-.417-.416h-1.25a.833.833 0 1 0 0 1.666h1.25z"
  }));
}